
// every message goes through this handler : a host app can route them all to its
// own logger (Explorers shows them in its terminal) instead of the console.
// setHandler() with nothing puts the console back.
let currentHandler = consoleHandler

function setHandler (handler = consoleHandler) {
    currentHandler = handler
}


function consoleHandler ({messagePrefix, deprecated, updated}) {
    console.warn(`${messagePrefix} : you are using deprecated property "${deprecated}". ` +
                      `Use "${updated}" instead.`)
}


function resolve (object, path) {
    if (!path.includes(".")) {
        return object[path]
    }
    let result = object
    for (let key of path.split(".")) {
        result = result[key]
        if (result === null || result === undefined) {
            return undefined
        }
    }
    return result
}


// Deprecated names stay readable, but nothing should advertise them - the editor's
// completion builder reads this list to keep them out of the popup. Non-enumerable,
// so it never shows up in an Object.keys / for-in walk of the object itself.
function markAsDeprecated (object, deprecated) {
    if (!Object.prototype.hasOwnProperty.call(object, "_deprecatedNames")) {
        Object.defineProperty(object, "_deprecatedNames", {value: [], configurable: true})
    }
    object._deprecatedNames.push(deprecated)
}


function addDeprecation ({messagePrefix, object, deprecated, updated, handler, onlyWhenCalled}) {

    markAsDeprecated(object, deprecated)

    let alreadyWarned
    function warn () {
        if (!alreadyWarned) {
            let warned = (handler || currentHandler)({messagePrefix, deprecated, updated})
            if (warned !== false) {
                alreadyWarned = true
            }
        }
    }
    if (onlyWhenCalled && typeof resolve(object, updated) === "function") {
        // defineProperty rather than an assignment : the host may already expose the
        // old name as a getter-only alias, which strict mode refuses to assign through
        Object.defineProperty(object, deprecated, {
            enumerable:   true,
            configurable: true,
            writable:     true,
            value: function (...args) {
                warn()
                return resolve(object, updated).apply(this, args)
            }
        })
    } else if (deprecated in object) {
        warn()
        object[updated] = object[deprecated]
    } else {
        // non-enumerable, like _deprecatedNames: the alias answers, but a walk of
        // the object (log, help, for-in) shows only the current name
        Object.defineProperty(object, deprecated, {
            enumerable:   false,
            configurable: true,

            set: function (value) {
                warn()
                object[updated] = value
            },

            get: function () {
                warn()
                return object[updated]
            }
        })
    }

}


// without an explicit handler, the one current *when the warning fires* is used :
// deprecations registered at module load still reach a handler set later by the host
function addDeprecations (messagePrefix, object, deprecations, {handler, onlyWhenCalled} = {}) {
    for (let deprecated in deprecations) {
        let updated = deprecations[deprecated]
        addDeprecation({messagePrefix, object, deprecated, updated, handler, onlyWhenCalled})
    }
}


// For renamed option keys inside a params object : warns (once per prefix and key)
// and copies the value to the new key, unless the new key is already set.
// Explorers has the same helper on top of its own logger (user_code/deprecate.js).
let warnedOptions = new Set()

function deprecateOptions (params, deprecations, messagePrefix) {
    for (let deprecated in deprecations) {
        if (!params || !(deprecated in params)) {
            continue
        }

        let updated   = deprecations[deprecated]
        let warnedKey = `${messagePrefix}.${deprecated}`

        if (!warnedOptions.has(warnedKey)) {
            warnedOptions.add(warnedKey)
            currentHandler({messagePrefix, deprecated, updated})
        }

        if (!(updated in params)) {
            params[updated] = params[deprecated]
        }
    }
}


export default {
    add:     addDeprecations,
    options: deprecateOptions,
    setHandler
}

